import type { VideoReference } from '@/api/types';
import { cardAspectRatio } from './cardAspect';

/** Отступ между карточками в долях ширины колонки: гэп тоже растит колонку. */
const GAP_UNITS = 0.05;

/** Разница высот меньше этого — колонки считаются равными, карточка идёт левее. */
const EPSILON = 1e-6;

/**
 * Раскладка Natural: карточка встаёт в самую короткую колонку, высота считается
 * из пропорций кадра. Место карточки зависит только от предыдущих, поэтому
 * подгрузка следующей страницы дописывает колонки снизу и не перекладывает уже
 * показанные карточки (браузерные CSS columns при этом перебалансируют всё).
 * Число колонок — `useGridColumns`.
 *
 * Возвращает индексы карточек в исходном списке по колонкам.
 */
export function distributeNatural(
  videos: readonly Pick<VideoReference, 'media' | 'orientation'>[],
  columns: number,
): number[][] {
  const count = Math.max(1, columns);
  const buckets: number[][] = Array.from({ length: count }, () => []);
  const heights = new Array<number>(count).fill(0);

  videos.forEach((video, index) => {
    let target = 0;
    for (let column = 1; column < count; column += 1) {
      if (heights[column]! < heights[target]! - EPSILON) target = column;
    }
    buckets[target]!.push(index);
    heights[target] = heights[target]! + 1 / cardAspectRatio(video) + GAP_UNITS;
  });

  return buckets;
}
